import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
interface PointsState {
  points: number;
}

const initialState: PointsState = {
  points: 0,
};

export const pointsSlice = createSlice({
  name: "points",
  initialState,
  reducers: {
    updatePoints(state, action) {
      state.points = action.payload.points;
    },
  },
});

export const loyaltyPointsActions = pointsSlice.actions;

export default pointsSlice.reducer;
